import * as AnalyticsConstants from '../constants';

import * as AnalyticsWorkers from './workers';

export default [
  {
    actionType: AnalyticsConstants.Actions.LOG_EVENT,
    handler: AnalyticsWorkers.onLogEvent,
    concur: 'takeEvery',
  },
];
